import { Create } from 'react-admin';
import BulkUploadPromotionalBalance from '../PromotionalBalance/BulkUploadPromotionalBalance';

const BulkPromotionalBalanceCreate = () => (
    <Create>
        <BulkUploadPromotionalBalance />
    </Create>
);

export default BulkPromotionalBalanceCreate;
